export const SIGNATURE_SETTINGS = {
    SIGNATURE_SETTINGS_LABEL: {
        key: 'SIGNATURE_SETTINGS_LABEL',
        value: 'Signature Settings'
    },
    FIELD_NAME_LABEL: {
        key: 'FIELD_NAME_LABEL',
        value: 'Field name'
    },
    FIELD_NAME_PLACEHOLDER: { // Can be reused from text input?
        key: 'FIELD_NAME_PLACEHOLDER',
        value: 'Enter the field name'
    },
    FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE: {
        key: 'FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE',
        value: 'Field name cannot contain any special characters or spaces other than hyphen(-)'
    },
    FIELD_NAME_EXISTS_ERROR_MESSAGE: {
        key: 'FIELD_NAME_EXISTS_ERROR_MESSAGE',
        value: 'Enter a unique field name. {{fieldName}} field name already exists!'
    }
};